//Generated File 
export default class AutoSaveBehavior{
	static readonly AlwaysSaveAndCommit = `AlwaysSaveAndCommit`;
	static readonly AlwaysSaveAsDraft = `AlwaysSaveAsDraft`;
	static readonly BasedOnRecordStatus = `BasedOnRecordStatus`;
}
